<template>
  <div>
    <div class="overlay">
      <div style="width: 50%">
        <div  style="height: 0.3rem !important;color: white;margin-bottom: 0.3rem;text-align: end;cursor: pointer;font-size: 0.3rem;" @click="close">✖</div>
        <video
          ref="videoPlayer"
          class="ship"
          :style="{ width: '100%', height: 'auto' }"
          :muted="isMuted"
          autoplay
          loop
          controls
          @play="handlePlay"
        >
          <source
            :src="message"
            type="video/mp4"
          />
        </video>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "VideoComponent",
  props: {
    message: {
      type: String,
    },
  },
  data() {
    return {
      isMuted: true, // 初始时静音
    };
  },
  methods: {
    //通知父组件视频关闭
    close() {
      this.$emit('closeVideo', '');
    },
    handlePlay() {
      this.isMuted = false; // 用户点击播放时取消静音
      this.$refs.videoPlayer.muted = false; // 确保视频不再静音
    },
  },
};
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9999;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/pages/wireless/components/video.vue